import React from 'react'
import { Box } from '@mui/material'
import '../../addplant-style.scss'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import useClientDetailsStyles from './styles'
import CustomTextField from '../../../../components/CustomTextField/CustomTextField'
import { get } from 'lodash'

const ClientDetails = ({ formik }) => {
  const classes = useClientDetailsStyles()

  // Function to add new email field
  const handleAddEmail = () => {
    const currentEmails = formik.values.clientDetails.email || ['']
    if (typeof currentEmails === 'string') {
      formik.setFieldValue('clientDetails.email', [currentEmails, ''])
    } else {
      formik.setFieldValue('clientDetails.email', [...currentEmails, ''])
    }
  }

  // Function to remove email field
  const handleRemoveEmail = (index) => {
    const currentEmails = formik.values.clientDetails.email
    if (Array.isArray(currentEmails)) {
      const newEmails = currentEmails.filter((_, idx) => idx !== index)
      formik.setFieldValue('clientDetails.email', newEmails)
    }
  }

  // Function to add new CC email field
  const handleAddCcEmail = () => {
    const currentCcEmails = formik.values.clientDetails.ccEmail || ['']
    if (typeof currentCcEmails === 'string') {
      formik.setFieldValue('clientDetails.ccEmail', [currentCcEmails, ''])
    } else {
      formik.setFieldValue('clientDetails.ccEmail', [...currentCcEmails, ''])
    }
  }

  // Function to remove CC email field
  const handleRemoveCcEmail = (index) => {
    const currentCcEmails = formik.values.clientDetails.ccEmail
    if (Array.isArray(currentCcEmails)) {
      const newCcEmails = currentCcEmails.filter((_, idx) => idx !== index)
      formik.setFieldValue('clientDetails.ccEmail', newCcEmails)
    }
  }

  // Initialize email arrays if they're strings
  React.useEffect(() => {
    if (
      typeof formik.values.clientDetails.email === 'string' &&
      formik.values.clientDetails.email
    ) {
      formik.setFieldValue('clientDetails.email', [
        formik.values.clientDetails.email,
      ])
    } else if (!formik.values.clientDetails.email) {
      formik.setFieldValue('clientDetails.email', [''])
    }

    // Initialize CC email
    if (
      typeof formik.values.clientDetails.ccEmail === 'string' &&
      formik.values.clientDetails.ccEmail
    ) {
      formik.setFieldValue('clientDetails.ccEmail', [
        formik.values.clientDetails.ccEmail,
      ])
    } else if (!formik.values.clientDetails.ccEmail) {
      formik.setFieldValue('clientDetails.ccEmail', [''])
    }
  }, [])

  const emailArray = Array.isArray(formik.values.clientDetails.email)
    ? formik.values.clientDetails.email
    : [formik.values.clientDetails.email || '']

  const ccEmailArray = Array.isArray(formik.values.clientDetails.ccEmail)
    ? formik.values.clientDetails.ccEmail
    : [formik.values.clientDetails.ccEmail || '']

  return (
    <div className={classes.root}>
      <div className="ptb_20">
        <Box
          sx={{
            '& .MuiTextField-root': { m: 1, width: '100%' },
          }}
          noValidate
          autoComplete="off"
        >
          <Grid container spacing={2} className="mb_20">
            <Grid item xs={12} md={4}>
              <div className="textfield">
                <CustomTextField
                  label="Client Name"
                  id="filled-size-small"
                  value={formik.values.clientDetails.clientName}
                  onChange={(value) =>
                    formik.setFieldValue(
                      `clientDetails.clientName`,
                      value.target.value
                    )
                  }
                  error={formik.errors?.clientDetails?.clientName}
                  helperText={
                    get(formik, `touched.clientDetails.clientName`) &&
                    get(formik, `errors.clientDetails.clientName`)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className="textfield">
                <CustomTextField
                  label="Designation"
                  id="filled-size-small"
                  value={formik.values.clientDetails.designation}
                  onChange={(value) =>
                    formik.setFieldValue(
                      `clientDetails.designation`,
                      value.target.value
                    )
                  }
                  error={formik.errors?.clientDetails?.designation}
                  helperText={
                    get(formik, `touched.clientDetails.designation`) &&
                    get(formik, `errors.clientDetails.designation`)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className="mt_8 y_n_toggle">
                <div className="contractor_access">
                  <div className="align_btw" style={{ height: '56px' }}>
                    <div className="toggle_txt">Client Access</div>
                    <label className="switch">
                      <input
                        type="checkbox"
                        defaultChecked={
                          formik.values.clientDetails.clientAccess
                        }
                        value={formik.values.clientDetails.clientAccess}
                        onChange={(value) =>
                          formik.setFieldValue(
                            `clientDetails.clientAccess`,
                            !formik.values.clientDetails.clientAccess
                          )
                        }
                      />
                      <span className="slider"></span>
                    </label>
                  </div>
                </div>
              </div>
            </Grid>

            <Grid item xs={12} md={4}>
              <div className="textfield">
                <CustomTextField
                  label="Contact No."
                  id="filled-size-small"
                  value={formik.values.clientDetails.contactNumber}
                  onChange={(value) =>
                    formik.setFieldValue(
                      `clientDetails.contactNumber`,
                      value.target.value
                    )
                  }
                  error={formik.errors?.clientDetails?.contactNumber}
                  helperText={
                    get(formik, `touched.clientDetails.contactNumber`) &&
                    get(formik, `errors.clientDetails.contactNumber`)
                  }
                />
              </div>
            </Grid>

            <Grid item xs={12} md={4}>
              <div className="textfield">
                <CustomTextField
                  label="GST"
                  id="filled-size-small"
                  value={formik.values.clientDetails.gst}
                  onChange={(value) =>
                    formik.setFieldValue(
                      `clientDetails.gst`,
                      value.target.value
                    )
                  }
                  error={formik.errors?.clientDetails?.gst}
                  helperText={
                    get(formik, `touched.clientDetails.gst`) &&
                    get(formik, `errors.clientDetails.gst`)
                  }
                />
              </div>
            </Grid>

            <Grid item xs={12} md={4}>
              <div className="textfield">
                <CustomTextField
                  label="PAN Number"
                  id="filled-size-small"
                  value={formik.values.clientDetails.panNumber}
                  onChange={(value) =>
                    formik.setFieldValue(
                      `clientDetails.panNumber`,
                      value.target.value
                    )
                  }
                  error={formik.errors?.clientDetails?.panNumber}
                  helperText={
                    get(formik, `touched.clientDetails.panNumber`) &&
                    get(formik, `errors.clientDetails.panNumber`)
                  }
                />
              </div>
            </Grid>

            {/* Email Fields */}
            {emailArray.map((email, index) => (
              <Grid
                item
                xs={12}
                md={4}
                key={`email-${index}`}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <div className="textfield" style={{ flex: 1 }}>
                  <CustomTextField
                    label={`Email ${emailArray.length > 1 ? index + 1 : ''}`}
                    id={`email-${index}`}
                    value={email}
                    onChange={(value) => {
                      const newEmails = [...emailArray]
                      newEmails[index] = value.target.value
                      formik.setFieldValue('clientDetails.email', newEmails)
                      // Trigger validation
                      formik.setFieldTouched(`clientDetails.email[${index}]`, true, true)
                    }}
                    error={get(formik.errors, `clientDetails.email[${index}]`)}
                    helperText={
                      (get(formik.touched, `clientDetails.email[${index}]`) ||
                        formik.submitCount > 0) &&
                      get(formik.errors, `clientDetails.email[${index}]`)
                    }
                  />
                </div>
                {index > 0 && (
                  <IconButton
                    onClick={() => handleRemoveEmail(index)}
                    style={{ marginLeft: '8px' }}
                  >
                    <DeleteOutlineIcon />
                  </IconButton>
                )}
                {index === emailArray.length - 1 && (
                  <IconButton
                    onClick={handleAddEmail}
                    style={{ marginLeft: '8px' }}
                  >
                    <AddCircleOutlineIcon />
                  </IconButton>
                )}
              </Grid>
            ))}

            {/* CC Email Fields */}
            {ccEmailArray.map((ccEmail, index) => {
              const fieldName = `clientDetails.ccEmail[${index}]`;
              const isTouched = get(formik.touched, fieldName);
              const fieldError = get(formik.errors, fieldName);
              const arrayError = get(formik.errors, 'clientDetails.ccEmail');
              const error = fieldError || (index === 0 && typeof arrayError === 'string' ? arrayError : null);
              const shouldShowError = (isTouched || formik.submitCount > 0) && error;

              return (
                <Grid
                  item
                  xs={12}
                  md={4}
                  key={`cc-email-${index}`}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <div className="textfield" style={{ flex: 1 }}>
                    <CustomTextField
                      label={`CC ${ccEmailArray.length > 1 ? index + 1 : ''}`}
                      id={`cc-email-${index}`}
                      value={ccEmail}
                      onChange={(value) => {
                        const newCcEmails = [...ccEmailArray]
                        newCcEmails[index] = value.target.value
                        formik.setFieldValue('clientDetails.ccEmail', newCcEmails)
                      }}
                      onBlur={() => {
                        formik.setFieldTouched(fieldName, true, true)
                      }}
                      error={shouldShowError}
                      helperText={shouldShowError ? error : ''}
                    />
                  </div>
                  {index > 0 && (
                    <IconButton
                      onClick={() => handleRemoveCcEmail(index)}
                      style={{ marginLeft: '8px' }}
                    >
                      <DeleteOutlineIcon />
                    </IconButton>
                  )}
                  {index === ccEmailArray.length - 1 && (
                    <IconButton
                      onClick={handleAddCcEmail}
                      style={{ marginLeft: '8px' }}
                    >
                      <AddCircleOutlineIcon />
                    </IconButton>
                  )}
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </div>
    </div>
  )
}

export default ClientDetails
